module.exports = __webpack_public_path__ + "img/eng-lang.f4f69793.svg";